import { useState, useEffect, useRef } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { FaEdit, FaTrash, FaFilePdf, FaPrint } from "react-icons/fa";
import { toast } from "react-toastify";

const API = process.env.REACT_APP_API_URL;
const API2 = process.env.REACT_APP_PDF_URL;


function PaymentSlips() {
  const [isOpen, setIsOpen] = useState(false);
  const [paymentSlips, setPaymentSlips] = useState([]);
  const [casefiles, setCasefiles] = useState([]);

  // modal
  const [showModal, setShowModal] = useState(false);
  const [showSlipModal, setShowSlipModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedSlip, setSelectedSlip] = useState(null);

  // form
  const [casefileId, setCasefileId] = useState("");
  const [amount, setAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [date, setDate] = useState("");
  const [note, setNote] = useState("");
  const [editId, setEditId] = useState(null);

  // search
  const [search, setSearch] = useState("");

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  const slipRef = useRef();

  const PAYMENT_MODES = ["Cash", "Bank Transfer", "Cheque", "Card", "Online"];

  useEffect(() => {
    document.title = "Payment Slips | Admin Panel";
    fetchPaymentSlips();
    fetchCasefiles();
  }, []);

  const fetchCasefiles = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API}/casefiles`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCasefiles(res.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchPaymentSlips = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API}/payment-slips`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPaymentSlips(res.data.data ?? res.data);
      console.log(res.data);
    } catch (err) {
      console.log(err);
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }
  };

  // filter
  const filteredSlips = paymentSlips.filter((item) => {
    const casefile = casefiles.find((c) => c.id === item.casefile_id);
    const label = casefile
      ? `${casefile.case_file_number ?? casefile.title ?? casefile.customer_name ?? ""}`.toLowerCase()
      : "";
    return (
      label.includes(search.toLowerCase()) ||
      (item.payment_mode ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(item.amount).includes(search)
    );
  });

  // pagination
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filteredSlips.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredSlips.length / itemsPerPage);
  const changePage = (page) => setCurrentPage(page);

  // ADD / UPDATE
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const payload = {
        casefile_id: casefileId,
        amount,
        payment_mode: paymentMode,
        date,
        note,
      };

      if (isEdit && editId) {
        await axios.put(`${API}/payment-slips/${editId}`, payload, config);
        toast.success("Payment slip updated 🎉");
      } else {
        await axios.post(`${API}/payment-slips`, payload, config);
        toast.success("Payment slip added 🚀");
      }

      fetchPaymentSlips();
      closeModal();
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response?.status === 401) {
          toast.error("Unauthorized token");
          localStorage.removeItem("token");
          window.location.href = "/login";
        } else if (err.response.data?.message) {
          toast.error(err.response.data.message);
        } else if (err.response.data?.errors) {
          Object.values(err.response.data.errors).forEach((messages) =>
            toast.error(messages[0])
          );
        } else {
          toast.error("Validation failed ❌");
        }
      } else {
        toast.error("Server not responding ❌");
      }
    }
  };

  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this payment slip?")) return;
    try {
      const token = localStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.delete(`${API}/payment-slips/${id}`, config);
      toast.success("Deleted ❌");
      fetchPaymentSlips();
    } catch (err) {
      console.log(err);
      if (err.response) {
        const status = err.response.status;
        const message = err.response.data?.message;
        if (status === 401) {
          toast.error("Unauthorized token ❌");
          localStorage.removeItem("token");
          window.location.href = "/login";
        } else if (status === 422) {
          toast.error(message || "Cannot delete this slip");
        } else if (status === 404) {
          toast.error(message || "Slip not found");
        } else {
          toast.error(message || "Delete failed");
        }
      } else {
        toast.error("Server not responding ❌");
      }
    }
  };

  // EDIT
  const handleEdit = (item) => {
    setCasefileId(item.casefile_id);
    setAmount(item.amount);
    setPaymentMode(item.payment_mode);
    setDate(item.date);
    setNote(item.note ?? "");
    setEditId(item.id);
    setIsEdit(true);
    setShowModal(true);
  };

  const openAddModal = () => {
    setCasefileId("");
    setAmount("");
    setPaymentMode("");
    setDate("");
    setNote("");
    setIsEdit(false);
    setShowModal(true);
  };

  const closeModal = () => {
    setCasefileId("");
    setAmount("");
    setPaymentMode("");
    setDate("");
    setNote("");
    setEditId(null);
    setIsEdit(false);
    setShowModal(false);
  };

  // VIEW SLIP

const handleViewSlip = (item) => {
  const token = localStorage.getItem("token");

  const url = `${API2}/payment-slip-download/${item.id}?token=${encodeURIComponent(token)}`;

  window.open(url, "_blank");
};
  // PRINT
  const handlePrint = () => {
    const content = slipRef.current.innerHTML;
    const win = window.open("", "_blank");
    win.document.write(`
      <html>
        <head>
          <title>Payment Slip</title>
          <style>
            body { font-family: 'Segoe UI', sans-serif; padding: 40px; color: #111; }
            .slip-box { max-width: 600px; margin: auto; border: 1px solid #ddd; padding: 32px; border-radius: 12px; }
            .slip-header { text-align: center; margin-bottom: 24px; }
            .slip-header h1 { font-size: 24px; margin: 0 0 4px; }
            .slip-header p { color: #888; font-size: 13px; margin: 0; }
            .slip-divider { border: none; border-top: 1px dashed #ccc; margin: 20px 0; }
            .slip-row { display: flex; justify-content: space-between; margin-bottom: 12px; font-size: 14px; }
            .slip-row .label { color: #666; }
            .slip-row .value { font-weight: 600; }
            .slip-amount { text-align: center; background: #f0f7ff; padding: 16px; border-radius: 8px; margin: 20px 0; }
            .slip-amount .amt { font-size: 32px; font-weight: 700; color: #2563eb; }
            .slip-footer { text-align: center; font-size: 12px; color: #aaa; margin-top: 24px; }
            .badge { display: inline-block; padding: 3px 10px; border-radius: 999px; font-size: 12px; font-weight: 600; background: #e0f2fe; color: #0369a1; }
          </style>
        </head>
        <body>${content}</body>
      </html>
    `);
    win.document.close();
    win.focus();
    win.print();
    win.close();
  };

  const getCasefileLabel = (id) => {
    const cf = casefiles.find((c) => c.id === id);
    if (!cf) return `Case #${id}`;
    return cf.case_number ?? cf.title ?? cf.name ?? `Case #${id}`;
  };

  const formatDate = (d) => {
    if (!d) return "—";
    return new Date(d).toLocaleDateString("en-AE", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const slipData = selectedSlip;

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar isOpen={isOpen} toggleSidebar={() => setIsOpen(!isOpen)} />

      <div className="flex-1 flex flex-col">
        <Header toggleSidebar={() => setIsOpen(!isOpen)} />

        <main className="p-6">
          {/* TOP */}
          <div className="flex flex-col md:flex-row justify-between gap-4 mb-6">
            <h2 className="text-2xl font-bold">Payment Slips</h2>
            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
              <input
                className="px-4 py-2 border rounded-lg w-full md:w-64"
                placeholder="Search by case, mode, amount..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
              />
              <button
                onClick={openAddModal}
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                + Add
              </button>
            </div>
          </div>

          {/* CARDS */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {currentItems.map((item) => (
              <div
                key={item.id}
                className="bg-white p-5 rounded-xl shadow hover:shadow-xl transition"
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs bg-blue-100 text-blue-700 font-semibold px-2 py-0.5 rounded-full">
                    {item.payment_mode}
                  </span>
                  <span className="text-xs text-gray-400">{formatDate(item.date)}</span>
                </div>

                <h3 className="font-bold text-gray-800 mt-1">
                  {item.casefile.case_number}
                </h3>

                <p className="text-2xl font-bold text-blue-600 mt-1">
                  AED {Number(item.amount).toLocaleString()}
                </p>

                {/* {item.note && (
                  <p className="text-sm text-gray-400 mt-1 truncate">{item.note}</p>
                )} */}

                <div className="flex justify-between mt-4">
                  <button
                    onClick={() => handleViewSlip(item)}
                    className="text-green-600 flex items-center gap-1 text-sm"
                  >
                    <FaFilePdf /> Download Slip
                  </button>
                  <button
                    onClick={() => handleEdit(item)}
                    className="text-blue-600 flex items-center gap-1 text-sm"
                  >
                    <FaEdit /> Edit
                  </button>
                  <button
                    onClick={() => handleDelete(item.id)}
                    className="text-red-600 flex items-center gap-1 text-sm"
                  >
                    <FaTrash /> Delete
                  </button>
                </div>
              </div>
            ))}

            {currentItems.length === 0 && (
              <div className="col-span-3 text-center text-gray-400 py-16">
                No payment slips found.
              </div>
            )}
          </div>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="flex justify-center mt-8 gap-2">
              <button
                disabled={currentPage === 1}
                onClick={() => changePage(currentPage - 1)}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Prev
              </button>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  onClick={() => changePage(i + 1)}
                  className={`px-3 py-1 border rounded ${
                    currentPage === i + 1 ? "bg-blue-600 text-white" : ""
                  }`}
                >
                  {i + 1}
                </button>
              ))}
              <button
                disabled={currentPage === totalPages}
                onClick={() => changePage(currentPage + 1)}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}
        </main>
      </div>

      {/* ADD / EDIT MODAL */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md p-6 rounded-2xl shadow-2xl">
            <h2 className="text-xl font-bold mb-4">
              {isEdit ? "Update Payment Slip" : "Add Payment Slip"}
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Case File */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Case File <span className="text-red-500">*</span>
                </label>
                <select
                  className="w-full border p-3 rounded-lg bg-white"
                  value={casefileId}
                  onChange={(e) => setCasefileId(e.target.value)}
                  required
                >
                  <option value="">-- Select Case File --</option>
                  {casefiles.map((cf) => (
                    <option key={cf.id} value={cf.id}>
                      {cf.case_file_number ?? cf.title ?? cf.name ?? `Case #${cf.id}`}
                    </option>
                  ))}
                </select>
              </div>

              {/* Amount */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Amount (AED) <span className="text-red-500">*</span>
                </label>
                <input
                  className="w-full border p-3 rounded-lg"
                  placeholder="0.00"
                  type="number"
                  min="0"
                  step="0.01"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </div>

              {/* Payment Mode */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Payment Mode <span className="text-red-500">*</span>
                </label>
                <select
                  className="w-full border p-3 rounded-lg bg-white"
                  value={paymentMode}
                  onChange={(e) => setPaymentMode(e.target.value)}
                  required
                >
                  <option value="">-- Select Mode --</option>
                  {PAYMENT_MODES.map((mode) => (
                    <option key={mode} value={mode}>
                      {mode}
                    </option>
                  ))}
                </select>
              </div>

              {/* Date */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Date <span className="text-red-500">*</span>
                </label>
                <input
                  className="w-full border p-3 rounded-lg"
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  required
                />
              </div>

              {/* Note */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Note
                </label>
                <textarea
                  className="w-full border p-3 rounded-lg resize-none"
                  placeholder="Optional note..."
                  rows={3}
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>

              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={closeModal}
                  className="w-full bg-gray-300 p-2 rounded"
                >
                  Cancel
                </button>
                <button className="w-full bg-blue-600 text-white p-2 rounded">
                  {isEdit ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

{/* SLIP VIEW MODAL */}
{showSlipModal && slipData && (
  <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
    <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden">

      {/* Modal Header */}
      <div
        className="flex items-center justify-between px-6 py-4 border-b"
        style={{ backgroundColor: "#02261D" }}
      >
        <h2 className="text-lg font-bold text-white">
          Payment Slip
        </h2>

        <div className="flex gap-2">
          <button
            onClick={handlePrint}
            className="flex items-center gap-1 text-sm bg-white text-[#02261D] px-3 py-1.5 rounded-lg hover:bg-gray-100"
          >
            <FaPrint /> Print
          </button>

          <button
            onClick={() => setShowSlipModal(false)}
            className="text-white hover:text-gray-300 text-xl font-bold px-2"
          >
            ×
          </button>
        </div>
      </div>

                {/* Printable Slip */}
      <div className="p-6" ref={slipRef}>
        <div className="slip-box border border-gray-200 rounded-xl p-8">

          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img
              src={process.env.REACT_APP_LOGO}
              alt="Company Logo"
              className="h-20 object-contain"
            />
          </div>

                {/* Slip Header */}
                <div className="text-center mb-6">
                  <h1 className="text-2xl font-bold tracking-tight">PAYMENT RECEIPT</h1>
                  <p className="text-gray-400 text-sm mt-1">
                    Slip #{slipData.id?.toString().padStart(6, "0")}
                  </p>
                </div>

                <hr className="border-dashed border-gray-300 my-4" />

                {/* Amount */}
                <div className="text-center bg-blue-50 rounded-xl py-5 mb-6">
                  <p className="text-sm text-gray-500 mb-1">Amount Paid</p>
                  <p className="text-4xl font-bold text-blue-600">
                    AED {Number(slipData.amount).toLocaleString("en-AE", {
                      minimumFractionDigits: 2,
                    })}
                  </p>
                </div>

                {/* Details */}
                <div className="space-y-3">
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Case File</span>
                    <span className="font-semibold text-right">
                      {getCasefileLabel(slipData.casefile_id)}
                    </span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Payment Mode</span>
                    <span className="inline-block bg-blue-100 text-blue-700 font-semibold text-xs px-3 py-0.5 rounded-full">
                      {slipData.payment_mode}
                    </span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Date</span>
                    <span className="font-semibold">{formatDate(slipData.date)}</span>
                  </div>

                  {slipData.note && (
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-500">Note</span>
                      <span className="font-semibold text-right max-w-xs">
                        {slipData.note}
                      </span>
                    </div>
                  )}
                </div>

                <hr className="border-dashed border-gray-300 my-5" />

                <p className="text-center text-xs text-gray-400">
                  Generated on {new Date().toLocaleDateString("en-AE", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
              </div>
            </div>
          </div>
        </div>

      )}
    </div>
    
  );
}

export default PaymentSlips;